module.exports = __webpack_public_path__ + "media/images/service-overview-1b468048ed7b5955199b2f85b5741be7.png";